import * as React from 'react';

import { Provider } from './context';
import { IScrollingContext, TScrollingBlocks } from '../../types/page/scrolling';

export const ScrollingProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [refBlocksState, setRefBlocksState] = React.useState<TScrollingBlocks>({});

  const valueContext: IScrollingContext = {
    refBlocksState,
    setRefBlocksState,
  };

  return <Provider value={valueContext}>{children}</Provider>;
};

ScrollingProvider.displayName = 'ScrollingProvider';
